import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'
import ReactTable from 'react-table'
import "react-table/react-table.css";

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';


class OrderViewAdmin extends Component {

    constructor(){
        super();
        this.view = this.view.bind(this)
        this.state = {
            userId:"",
            user :{},
            orderList: {}
        };
    }
    
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId:data.key,
                        user:data.val()
                      });

                    }.bind(this));
            }else{
              this.props.history.push("/login");
            }
        });   
    }


    componentDidMount(){
        let quotation = ref.child("PurchaseOrder")
            quotation.on("value", function(snap){
                this.setState({
                    orderList : snap.val()
                })
            }.bind(this))
    }

    
    view(index){
        window.location.assign("/purchaseorder/"+index+"/view")
        //alert("Page not yet created" + index)
    }
     remove(index){
        if(window.confirm("Are you sure you want to delete this order")===true){
            ref.child("PurchaseOrder").child(index).remove();
        }
    }

    render() {
        var x = [];
        this.state.orderList &&
        Object.keys(this.state.orderList).map(key => {
            let list = this.state.orderList[key]
                list.id = key
                list.name = list.name.toUpperCase();
                list.address = list.address.toUpperCase();
            x.push(list)
            })
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="List of Order" />
                            <div className="block ">
                                <ReactTable
                                    data={x}
                                    columns={[
                                        {
                                            Header: "Order Code",
                                            accessor : "id"
                                        },
                                        {
                                            Header: "For Quotation",
                                            accessor : "quoteNumber"
                                        },
                                        {
                                            Header: "Customer Name",
                                            accessor : "name",
                                            filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                        },
                                        {
                                            Header: "Address",
                                            accessor : "address",
                                            filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                        },
                                        {
                                            Header: "Date of Order",
                                            accessor : "date"
                                        },
                                        {
                                            Header: 'Action',
                                            accessor : "id",
                                            Cell : row => (
                                                <span>
                                                <button onClick={()=>this.view(row.value)}><i className="fa fa-eye"></i></button>
                                                <button onClick={()=>this.remove(row.value)}><i className="fa fa-trash-o"></i></button>                                                 
                                                </span>
                                            )
                                                                               
                                        }
                                    ]}
                                    
                                    filterable ={true}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                />        
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default OrderViewAdmin;



// WEBPACK FOOTER //
// ./src/components/OrderViewAdmin.js